import { useEffect, useRef } from "react";

const PayPalButton = ({ amount, currency, createPaymentRecord, onSuccess }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const scriptId = "paypal-sdk";

        const renderButton = () => {
            if (window.paypal && window.paypal.Buttons && containerRef.current) {
                containerRef.current.innerHTML = "";

                window.paypal.Buttons({
                    style: {
                        layout: 'vertical',
                        color: 'gold',
                        shape: 'rect',
                        label: 'paypal'
                    },
                    createOrder: async (data, actions) => {
                        console.log("PayPal createOrder Triggered");
                        try {
                            // 1. Create record in our DB first to get the ID
                            // We pass specific metadata to link it
                            console.log("Calling calling createPaymentRecord()...");
                            const paymentRecord = await createPaymentRecord();
                            console.log("Received paymentRecord:", paymentRecord);

                            // Backend returns { payment_id: "...", provider: "...", ... }
                            // We need to check for payment_id, not id
                            if (!paymentRecord || !paymentRecord.payment_id) {
                                console.error("Missing payment_id in record:", paymentRecord);
                                throw new Error("Could not create payment record (missing payment_id)");
                            }

                            // 2. Create PayPal order with our internal ID as custom_id
                            return actions.order.create({
                                purchase_units: [{
                                    amount: {
                                        value: amount.toString(),
                                        currency_code: currency
                                    },
                                    custom_id: paymentRecord.payment_id, // This is the link!
                                    description: `Cotisation Hafani`
                                }]
                            });
                        } catch (err) {
                            console.error("Error creating order:", err);
                            // Fallback or alert user
                            throw err;
                        }
                    },
                    onApprove: async (data, actions) => {
                        try {
                            const details = await actions.order.capture();
                            // Optional: Call backend to confirm immediately, 
                            // but webhook will handle the definitive status update.
                            if (onSuccess) onSuccess(details);
                        } catch (err) {
                            console.error("Error capturing order:", err);
                        }
                    },
                    onError: (err) => {
                        console.error("PayPal Error:", err);
                    }
                }).render(containerRef.current);
            }
        };

        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            const clientId = "AdZBMaH3NI1azlBp8QD0gzG8dRgZFgBEipQMwK6Mak9z7N1VD64nHjTCgDzBhN49GFZ6JgcKku7IWekp"; // From previous file
            script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}&intent=capture`;
            script.id = scriptId;
            script.async = true;
            script.crossOrigin = "anonymous";
            script.onload = renderButton;
            document.body.appendChild(script);
        } else {
            renderButton();
        }
    }, [amount, currency, createPaymentRecord, onSuccess]);

    return <div ref={containerRef} className="w-full relative z-0"></div>;
};

export default PayPalButton;


